import * as React from "react";

import { cardOutlineClassName } from "./card";
import { cn } from "../../lib/utils";

const surfaceCardClassName = cn("rounded-2xl bg-card", cardOutlineClassName, "shadow-[var(--shadow-widget)]");

const SurfaceCard = React.forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<"div">>(
  ({ className, ...props }, ref) => {
    return <div ref={ref} data-slot='surface-card' className={cn(surfaceCardClassName, className)} {...props} />;
  },
);

SurfaceCard.displayName = "SurfaceCard";

export { SurfaceCard, surfaceCardClassName };
